<template>
  <div class="fullview" v-if="isProcessing === true">
    <div class="loading-spacer"></div>
    <vue-loading 
      type="spiningDubbles"
      color="#aaa"
      :size="{ width: '100px', height: '100px' }">
    </vue-loading>
  </div>
</template>

<script>
import { VueLoading }  from 'vue-loading-template';

export default {
  name: 'Loading',
  props: {
    isProcessing: Boolean,
  },
  components: {
    VueLoading,
  }
}
</script>

<style>
.fullview {
  opacity: 10000;
  width: 100%;
  height: 100%;
  background: rgba(245, 245, 245, 0.9);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10000;
}
.loading-spacer {
  height: 30%;
}
</style>